import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ui-full"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "ui-button-content" }, " Confirmar ", -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_produto_imagens = _resolveComponent("produto-imagens")!
  const _component_produto_codigos = _resolveComponent("produto-codigos")!
  const _component_produto_precos = _resolveComponent("produto-precos")!
  const _component_produto_estoque = _resolveComponent("produto-estoque")!
  const _component_produto_peso_medidas = _resolveComponent("produto-peso-medidas")!
  const _component_produto_simulador_frete = _resolveComponent("produto-simulador-frete")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return ((_ctx.state.computedVisivel))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_modal, {
          keyboard: false,
          centered: "",
          width: "100%",
          "wrap-class-name": "ui-full-modal",
          visible: _ctx.state.computedVisivel,
          "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.computedVisivel) = $event)),
          title: 'Variação do produto: ' + _ctx.props.descricaoProduto + _ctx.montarVariacaoProduto()
        }, {
          footer: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "ui-button -second",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.computedVisivel = false))
              }, " Voltar "),
              _createElementVNode("button", {
                class: "ui-button -primary",
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmarDadosVariacao()))
              }, _hoisted_3)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_skeleton, { loading: false }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, { layout: "vertical" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_produto_imagens, {
                      imagens: _ctx.state.produtoDefinicao.imagens,
                      "onUpdate:imagens": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.produtoDefinicao.imagens) = $event))
                    }, null, 8, ["imagens"]),
                    _createVNode(_component_produto_codigos, {
                      sku: _ctx.state.produtoDefinicao.sku,
                      "onUpdate:sku": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.produtoDefinicao.sku) = $event)),
                      codigoBarras: _ctx.state.produtoDefinicao.codigoBarras,
                      "onUpdate:codigoBarras": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.produtoDefinicao.codigoBarras) = $event)),
                      codigoErp: _ctx.state.produtoDefinicao.codigoErp,
                      "onUpdate:codigoErp": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.produtoDefinicao.codigoErp) = $event))
                    }, null, 8, ["sku", "codigoBarras", "codigoErp"]),
                    _createVNode(_component_produto_precos, {
                      precos: _ctx.state.produtoDefinicao.precos,
                      "onUpdate:precos": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.produtoDefinicao.precos) = $event)),
                      "precos-por-quantidades": _ctx.state.produtoDefinicao.precosPorQuantidades,
                      "onUpdate:precosPorQuantidades": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.produtoDefinicao.precosPorQuantidades) = $event))
                    }, null, 8, ["precos", "precos-por-quantidades"]),
                    _createVNode(_component_produto_estoque, {
                      gerenciarEstoque: _ctx.state.produtoDefinicao.gerenciarEstoque,
                      "onUpdate:gerenciarEstoque": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.produtoDefinicao.gerenciarEstoque) = $event)),
                      disponibilidade: _ctx.state.produtoDefinicao.disponibilidade,
                      "onUpdate:disponibilidade": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.produtoDefinicao.disponibilidade) = $event)),
                      regraSemEstoque: _ctx.state.produtoDefinicao.regraSemEstoque,
                      "onUpdate:regraSemEstoque": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.produtoDefinicao.regraSemEstoque) = $event)),
                      quantidadeEstoque: _ctx.state.produtoDefinicao.quantidadeEstoque,
                      "onUpdate:quantidadeEstoque": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.produtoDefinicao.quantidadeEstoque) = $event)),
                      venderMultiplos: _ctx.state.produtoDefinicao.venderMultiplos,
                      "onUpdate:venderMultiplos": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.produtoDefinicao.venderMultiplos) = $event))
                    }, null, 8, ["gerenciarEstoque", "disponibilidade", "regraSemEstoque", "quantidadeEstoque", "venderMultiplos"]),
                    _createVNode(_component_produto_peso_medidas, {
                      peso: _ctx.state.produtoDefinicao.peso,
                      "onUpdate:peso": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.produtoDefinicao.peso) = $event)),
                      altura: _ctx.state.produtoDefinicao.altura,
                      "onUpdate:altura": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.produtoDefinicao.altura) = $event)),
                      largura: _ctx.state.produtoDefinicao.largura,
                      "onUpdate:largura": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.produtoDefinicao.largura) = $event)),
                      comprimento: _ctx.state.produtoDefinicao.comprimento,
                      "onUpdate:comprimento": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.produtoDefinicao.comprimento) = $event))
                    }, null, 8, ["peso", "altura", "largura", "comprimento"]),
                    _withDirectives(_createVNode(_component_produto_simulador_frete, {
                      codigoProduto: _ctx.state.produtoDefinicao.codigoProduto,
                      codigoProdutoDefinicao: _ctx.state.produtoDefinicao.codigo
                    }, null, 8, ["codigoProduto", "codigoProdutoDefinicao"]), [
                      [_vShow, (_ctx.state.produtoDefinicao.codigoProduto > 0 && _ctx.state.produtoDefinicao.codigo > 0)]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["visible", "title"])
      ]))
    : _createCommentVNode("", true)
}